import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import useSlingApi from '@sdk/api/useSlingApi';
import getErrorForToast from '@sdk/api/utils/getErrorForToast';
import useToast from '@sdk/common/toast/useToast';

import { getShiftTaskDetailsQueryKey } from '@web/shiftTasks/utils/getQueryKey';
import { DEFAULT_CACHE_TIME } from '@web/constants';
import { useShiftTaskMappers } from '@web/shiftTasks/hooks/useShiftTaskMappers';

export const useGetShiftTaskDetails = (id: number, onError: VoidFunction) => {
  const { shiftTasks } = useSlingApi();
  const detailsQueryKey = getShiftTaskDetailsQueryKey(id);
  const { showErrorToast } = useToast();
  const { mapTaskInstanceAPIToUI } = useShiftTaskMappers();

  const result = useQuery({
    queryKey: detailsQueryKey,
    cacheTime: DEFAULT_CACHE_TIME,
    retry: 3,
    queryFn: async () => {
      const { data } = await shiftTasks.getInstance(id);

      return mapTaskInstanceAPIToUI(data);
    },
  });

  useEffect(() => {
    if (result.error) {
      showErrorToast(getErrorForToast(result.error));
      onError();
    }
  }, [result.error, showErrorToast, onError]);

  return result;
};
